import { COMMON_EVENT_NAMES } from "../../constants";

export const EVENT_NAME = {
  NAVIGATED: COMMON_EVENT_NAMES.NAVIGATED
};
